/*
 *服务 接口
 *和后端交互的接口
 *
 *
 */

import { Common } from "@/utils/http";
import { SERVICE_CODE, STATE_CODE } from "@/config/interface";
import { BASE_CONFIG } from "@/config/config";
import axios from "axios";
import { Message } from "element-ui";

let InterfaceService = {
  //--------------上传公共服务 start--------------

  //一次性获取签名 用于:多文件file 一次性上传 遍历文件的时间很短 一般在签名有效期以内 所以不需要判断签名时效
  getOssSignatureDisposable: (
    params,
    callback,
    errorCallback,
    loadingStartCb,
    loadingEndCb
  ) => {
    Common.request(
      SERVICE_CODE.OSS_SIGNATURE,
      params,
      (data) => {
        let respData = data.respData;
        typeof callback === "function" && callback(respData);
      },
      (data) => {
        if (data.respData && data.respData.respMsg) {
          Message.error(data.respData.respMsg);
        }
        typeof errorCallback === "function" && errorCallback(data);
      },
      loadingStartCb,
      loadingEndCb
    );
  },
  getOssSignature: (
    params,
    callback,
    errorCallback,
    loadingStartCb,
    loadingEndCb
  ) => {
    let signature = sessionStorage.getItem("signature") || "{}";
    signature = JSON.parse(signature);
    let now = new Date().getTime();
    if (
      signature &&
      signature["expire"] > now &&
      signature.type === params.type
    ) {
      //签名未过期 直接上传
      typeof callback === "function" && callback(signature);
    } else {
      //签名过期 直接上传
      sessionStorage.removeItem("signature");
      Common.request(
        SERVICE_CODE.OSS_SIGNATURE,
        params,
        (data) => {
          let respData = data.respData;
          respData.type = params.type; //多一个type标记 如果传入type和缓存里的type不一致 则无条件刷新签名
          sessionStorage.setItem("signature", JSON.stringify(respData));

          typeof callback === "function" && callback(respData);
        },
        (data) => {
          typeof errorCallback === "function" && errorCallback(data);
        },
        loadingStartCb,
        loadingEndCb
      );
    }
  },
  isImgsFun: (name) => {
    let imgsFormat = ["png", "jpg", "jpeg", "svg", "gif", "webp"];
    let c = name.split(".");
    let d = imgsFormat.filter(
      (item) => item === c[c.length - 1].toLocaleLowerCase()
    );
    if (d.length != 0) {
      return true;
    } else {
      return false;
    }
  },
  /*
    *   signature  后端获取的签名
    *   file       上传文件对象
        dirName    文件名 string
            product/[productId]/main/     (商品图：商品/商品id/主图/)
            product/[productId]/detail/   (商品图：商品/商品id/主图/)
            company/                    (公司/)
        pos        多文件上传 pos对应文件的索引 单文件上传输入0即可
        callBack   oss上传成功回调
    *
    */
  uploadToOss: (
    signature,
    file,
    dirName,
    pos,
    callBack,
    reName,
    timestampFlag
  ) => {
    let fileName, key;
    if (signature.linkType && signature.languageType) {
      fileName = file.name; //文件是否重命名
      key = `${signature.dir}/${signature.linkType}/${signature.languageType}/${new Date().getTime() + "_" + fileName}`;
      // 如果是图片类型就修改上传路径
      // 是否为图片格式
      if (InterfaceService.isImgsFun(fileName)) {
        key = `${signature.dir}/${signature.linkType}/${signature.languageType}/img/${new Date().getTime() + "_" + fileName}`;
      }
      signature.perfectUrl = `${signature.host}/${key}`;
    } else {
      fileName = new Date().getTime() + file.name; //文件是否重命名
      key = signature.dir + dirName;
      if (timestampFlag) {
        //是否加时间戳区别文件名
        key = key + new Date().getTime() + "/";
      }
      key += fileName;
    }
    let param = new FormData(); //创建form对象
    let now = Date.parse(new Date()) / 1000;
    param.append("key", key);
    param.append("policy", signature.policy);
    param.append("OSSAccessKeyId", signature.accessid);
    param.append("success_action_status", "200");
    param.append("signature", signature.signature);
    param.append("file", file, file.name);
    let config = {
      headers: { "Content-type": "multipart/form-data" }
      // withCredentials:true
    };
    (function(pos) {
      axios
        .post(signature.host, param, config)
        .then((response) => {
          //console.log(pos)
          //console.log(file)
          if (response.status === 200) {
            typeof callBack === "function" &&
              callBack(pos, file, dirName, signature, fileName);
          } else {
            Message.error("oss签名获取错误");
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    })(pos);
  },
  //--------------oss静态文件获取 start--------------
  // oss获取文件
  getOssFile: (ossUrl, callback) => {
    axios.get(ossUrl).then((response) => {
      if (response.status === 200) {
        typeof callback === "function" && callback(response.data);
      }
    });
  },
  // 获取Oa登录地址
  getLoginFormOa: (ossUrl, callback) => {
    axios.get(ossUrl).then((response) => {
      if (response.status === 200) {
        typeof callback === "function" && callback(response.data);
      }
    });
  }
};

const interMap = [
  { method: "testInter", code: SERVICE_CODE.TEST_CODE },
  { method: "login", code: SERVICE_CODE.LOGIN, showMsg: false },
  { method: "queryNewsList", code: "hkwebsite_200001" },
  /* 配置接口 */
  { method: "queryDataList", code: "11310001" },
  { method: "queryDataDetail", code: "11310002" },
  { method: "addAndEditData", code: "11310003" },
  { method: "deleteData", code: "11310004" },
  { method: "logOut", code: "2030008" },
];

let interAPI = {};

interMap.forEach((m) => {
  interAPI[m.method] = (
    params,
    callback,
    errorCallback,
    loadingStartCb,
    loadingEndCb
  ) => {
    Common.request(
      m.code,
      params,
      (data) => {
        //console.log(data)
        typeof callback === "function" && callback(data);
      },
      (data) => {
        if (m.showMsg && data.respData && data.respData.respMsg) {
          Message.error(data.respData.respMsg);
        } else if (
          m.showError &&
          data.respData &&
          data.respData.respCode === "9999" &&
          data.respData.respMsg
        ) {
          if (data.respData.respMsg) {
            Message.error(data.respData.respMsg);
          }
        }
        typeof errorCallback === "function" && errorCallback(data);
      },
      loadingStartCb,
      loadingEndCb
    );
  };
});
Object.assign(InterfaceService, interAPI);

export { InterfaceService };



// WEBPACK FOOTER //
// ./src/services/api.js